<div id="backButtonContainer">
  <button mat-icon-button (click)="backToCollaboratorView()" (keydown.enter)="backToCollaboratorView()">
    <mat-icon class="material-symbols-outlined">arrow_back</mat-icon>
  </button>
</div>
<div id="nameAndButtonContainer" class="flexRowContainer justifyContentSpaceBetween">
  <p class="headline-small">{{ documentHal?.title }}</p>
  <div class="flexRowContainer justifyFlexEnd">
    <button mat-button (click)="formActionsHelperService.saveFormProgress(documentHal)"
            (keydown.enter)="formActionsHelperService.saveFormProgress(documentHal)">
      {{ 'collaborator.previewFormMetadata.buttons.save' | translate }}
    </button>
    <button mat-flat-button (click)="formActionsHelperService.completeDataCapturing(documentHal)"
            (keydown.enter)="formActionsHelperService.completeDataCapturing(documentHal)">
      {{ 'collaborator.previewFormMetadata.buttons.complete' | translate }}
    </button>
  </div>
</div>
<div id="textContainer">
  <p class="body-large">{{ 'collaborator.previewFormMetadata.text' | translate }}</p>
</div>
